import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import SearchSubprojectTable from './SearchSubprojectTable'

export default function SearchSubprojectWidgets(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const [formSchema, setFormSchema] = useState(props.schema)

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        <SearchSubprojectTable schema={formSchema?.form} />
      </Panel>
    </>
  )
}
